import { gql } from '@apollo/client';

const getValidataQuery = gql`
  query GetValidataQuery($addressToken: String!) {
    validata {
      getConfidenceSignalsByFields(input: { addressToken: $addressToken }) {
        confidenceSignals {
          attributeName
          confidenceLevel
          reason
        }
      }
    }
  }
`;

export default getValidataQuery;
